import * as chrono from 'chrono-node'
import * as yup from 'yup'

const invalidDate = new Date('')

export const chronoDate = (chronoInstance: chrono.Chrono) =>
  yup.date().transform(function (value, originalValue) {
    value = chronoInstance.parseDate(originalValue)
    return value ? value : invalidDate
  })
